import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const TipsAndAdvice = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddTipsAndAdvice = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditTipsAndAdvice = () => {
  return (
    
      
        <Edit />
      
    
  );
};
